import DATA_INTRO_TCA from "./Introduction/301DataIntroTCA";
import { DATA_BENEFITS_TCA_1 } from "./Introduction/302DataBenefitsTCA";
import { DATA_BENEFITS_TCA_2 } from "./Introduction/303DataBenefitsTCA";
import { DATA_BENEFITS_TCA_3 } from "./Introduction/304DataBenefitsTCA";
import { DATA_CHARACTERS_TCA } from "./Introduction/305DataCharactersTCA";
import { DATA_ND_DEMO_TCA_1 } from "./NDDemo/306DataNDDemoTCA1";
import { DATA_ND_DEMO_TCA_2 } from "./NDDemo/307DataNDDemoTCA2";
import { DATA_ND_DEMO_TCA_3 } from "./NDDemo/308DataNDDemoTCA3";
import { DATA_ND_DEMO_TCA_4 } from "./NDDemo/309DataNDDemoTCA4";
import { DATA_ND_DEMO_TCA_5 } from "./NDDemo/310DataNDDemoTCA5";
import { DATA_ND_DEMO_TCA_END } from "./NDDemo/311DataNDDemoTCAEnd";
import { DATA_NOT_DEMO_TCA_1 } from "./NOTDemo/312DataNOTDemoTCA1";
import { DATA_NOT_DEMO_TCA_2 } from "./NOTDemo/313DataNOTDemoTCA2";
import { DATA_NOT_DEMO_TCA_3 } from "./NOTDemo/314DataNOTDemoTCA3";
import { DATA_NOT_DEMO_TCA_4 } from "./NOTDemo/315DataNOTDemoTCA4";
import { DATA_NOT_DEMO_TCA_END } from "./NOTDemo/316DataNOTDemoTCAEnd";

const TCA_WORKFLOW = [
  { page: "ILO_301", type: "intro-template" as TemplateType, data: DATA_INTRO_TCA },
  { page: "ILO_302", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_TCA_1 },
  { page: "ILO_303", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_TCA_2 },
  { page: "ILO_304", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_TCA_3 },
  { page: "ILO_305", type: "characters-template" as TemplateType, data: DATA_CHARACTERS_TCA },
  { page: "ILO_306", type: "journey-two-template" as TemplateType, data: DATA_ND_DEMO_TCA_1 },
  { page: "ILO_307", type: "journey-two-template" as TemplateType, data: DATA_ND_DEMO_TCA_2 },
  { page: "ILO_308", type: "journey-two-template" as TemplateType, data: DATA_ND_DEMO_TCA_3 },
  { page: "ILO_309", type: "journey-two-template" as TemplateType, data: DATA_ND_DEMO_TCA_4 },
  { page: "ILO_310", type: "journey-two-template" as TemplateType, data: DATA_ND_DEMO_TCA_5 },
  { page: "ILO_311", type: "end-template" as TemplateType, data: DATA_ND_DEMO_TCA_END },
  { page: "ILO_312", type: "journey-two-template" as TemplateType, data: DATA_NOT_DEMO_TCA_1 },
  { page: "ILO_313", type: "journey-two-template" as TemplateType, data: DATA_NOT_DEMO_TCA_2 },
  { page: "ILO_314", type: "journey-two-template" as TemplateType, data: DATA_NOT_DEMO_TCA_3 },
  { page: "ILO_315", type: "journey-two-template" as TemplateType, data: DATA_NOT_DEMO_TCA_4 },
  { page: "ILO_316", type: "end-template" as TemplateType, data: DATA_NOT_DEMO_TCA_END },
];

export default TCA_WORKFLOW;
